exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".content-wrapper{max-width:1170px;margin:auto;position:relative}@media (max-width:1200px){.content-wrapper{border-left:20px solid transparent;border-right:20px solid transparent}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62351b9e","scoped":false,"hasInlineConfig":true}!./src/components/content-wrapper/content-wrapper.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-62351b9e","scoped":false,"hasInlineConfig":true}!./src/components/content-wrapper/content-wrapper.css
// module chunks = index